const CancelOrderModal = ({ show, onClose, order, orderNo, navigate }) => {

    if (!show) return null;

    const handleCancel = () => {
        navigate(`/accounts/orders/${orderNo}/cancel`, {
            state: {
                items: order.order_items,
                orderNo,
            },
        });
    };

    return (
        <div className="modal-overlay-history">

            <div className="modal-box">

                <h3>Cancel Order</h3>
                <p>Are you sure you want to cancel this order?</p>

                <div className="modal-actions">

                    <button onClick={onClose}>
                        KEEP ORDER
                    </button>

                    <button onClick={handleCancel}>
                        CANCEL ORDER
                    </button>

                </div>

            </div>

        </div>
    );
};

export default CancelOrderModal;